import request from "@/utils/request";

export const getRoutePath = () => request.get('getRouters/wisdom')